import React, { useState } from "react";
import { ImSpinner2 } from "react-icons/im";
import {
  formatCreatedAt,
  formatTime,
} from "../utils/commonUtils";

const UserReferrals = ({ status, error, userReferrals, userDetail }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentReferrals = userReferrals.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(userReferrals?.length / itemsPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const countries = JSON.parse(localStorage.getItem("country"));
  const states = JSON.parse(localStorage.getItem("state"));
  const provinces = JSON.parse(localStorage.getItem("province"));

  const getCountryNameFromId = (countryId) => {
    const country = countries?.find(
      (country) => country.id === parseInt(countryId, 10)
    );
    return country ? country.name : "N/A";
  };

  const getStateNameFromId = (stateId) => {
    const state = states?.find((state) => state.id === parseInt(stateId, 10));
    return state ? state.name : "N/A";
  };

  const getCityNameFromId = (provinceId) => {
    const province = provinces?.find(
      (province) => province.id === parseInt(provinceId, 10)
    );
    return province ? province.name : "N/A";
  };

  return (
    <div className="w-full">
      <div className="w-full px-6 py-6 bg-white rounded-lg shadow">
        <div className="flex justify-between items-center bg-gray-100 p-2 border-b">
          <div className="flex items-center gap-4">
            <h1 className="text-[18px] text-[#1A1C21] font-medium tracking-[0.09px]">
              Referrals
            </h1>
          
          </div>
        </div>
        <div className="overflow-x-auto w-full">
          <table className="w-full text-sm">
            <thead className="bg-gray-100">
              <tr className="border-b text-center">
                <th className="px-4 py-2 text-base font-medium text-[#1A1C21]">
                  No.
                </th>
                <th className="px-4 py-2 text-base font-medium text-[#1A1C21]">
                  Name
                </th>
                <th className="px-4 py-2 text-base font-medium text-[#1A1C21]">
                  Country
                </th>
                <th className="px-4 py-2 text-base font-medium text-[#1A1C21]">
                  State
                </th>
                <th className="px-4 py-2 text-base font-medium text-[#1A1C21]">
                  City
                </th>
                <th className="px-4 py-2 text-base font-medium text-[#1A1C21]">
                  Created
                </th>
                <th className="px-4 py-2 text-base font-medium text-[#1A1C21]">
                  Time
                </th>
              </tr>
            </thead>
            <tbody>
              {status === "failed" ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="flex justify-center items-center">
                      Error. {error}.{" "}
                      <span className="text-base font-semibold ">
                        {" "}
                        Try again later
                      </span>
                    </div>
                  </td>
                </tr>
              ) : status === "loading" ? (
                <tr>
                  <td colSpan="12" className="text-center py-4">
                    <div className="m-auto">
                      <ImSpinner2 className="animate-spin h-8 w-8 text-gray-500" />
                    </div>
                  </td>
                </tr>
              ) : (
                currentReferrals.map((referral, index) => (
                  <tr key={referral.id} className="border-b text-center">
                    <td className="px-4 py-2 text-sm text-[#1A1C21]">
                      {indexOfFirstItem + index + 1}
                    </td>
                    <td className="px-4 py-2 text-sm text-[#1A1C21]">
                      <div className=" flex flex-col items-center gap-2">
                        <div className="flex  items-center gap-2 text-base font-semibold">
                          <p className="">{referral.firstname}</p>
                          <p>{referral.lastname}</p>
                        </div>
                        <p>{referral.phone}</p>
                        <p className=" w-48 break-words text-gray-500">{referral.email}</p>
                      </div>
                    </td>
                    <td className="px-4 py-2 text-sm text-[#1A1C21]">
                      <p>{getCountryNameFromId(referral.country)}</p>
                    </td>
                    <td className="px-4 py-2 text-sm text-[#1A1C21]">
                      <p>{getStateNameFromId(referral.state)}</p>
                    </td>
                    <td className="px-4 py-2 text-sm text-[#1A1C21]">
                      <p>{getCityNameFromId(referral.province)}</p>
                    </td>
                    <td className="px-4 py-2 text-sm whitespace-nowrap text-[#1A1C21]">
                      {formatCreatedAt(referral.created_at)}
                    </td>
                    <td className="px-4 py-2 text-sm whitespace-nowrap text-[#1A1C21]">
                      {formatTime(referral.created_at)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between px-4 py-2">
          <button
            onClick={prevPage}
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded-md ${
              currentPage === 1
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            Previous
          </button>
          <button
            onClick={nextPage}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 rounded-md ${
              currentPage === totalPages
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserReferrals;
